import "../common/common.js";
import { loginSession } from '../common/common.js';
import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';

// piはグローバルに保持
let pi = null;

// スライドの読み込み
async function initSlider() {
    const slideThumb = new Swiper("#slide-thumb", {
        loop: false,
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesProgress: true,
    });
    const slideMain = new Swiper("#slide", {
        loop: true,
        spaceBetween: 10,
        navigation: false,
        thumbs: {
            swiper: slideThumb,
        },
    });

    slideThumb.slides.forEach((thumb, index) => {
        thumb.addEventListener("click", () => {
            slideMain.slideTo(index);
        });
    });

    slideMain.on('slideChange', () => {
        const activeIndex = slideMain.realIndex;
        slideThumb.slideTo(activeIndex);
    });

    slideMain.on('transitionEnd', () => {
        const activeIndex = slideMain.realIndex;
        slideThumb.slideTo(activeIndex, 0);
    });
}


document.addEventListener("DOMContentLoaded", async () => {
    const urlParams = new URLSearchParams(window.location.search);
    pi = urlParams.get("pi");

    if (pi) {
        // チケット情報読み込み
        try {
            const response = await fetch("/system/user/ticket/ticket-info-fetch.php", {
                method: "POST",
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                body: `pi=${encodeURIComponent(pi)}`
            });
            const result = await response.json();
            if (result.success === true) {
                // チケット名
                document.getElementById('ticket-name').innerText = result.ticketName;
                // 店名
                document.getElementById('location').innerText = result.locationName;
                // スライド組み立て関数
                const slideDom = slideCreate(result.slideArr);
                // スライドサムネ
                document.getElementById('slide-thumb').appendChild(slideDom);
                const slideDomClone = slideDom.cloneNode(true);
                document.getElementById('slide').appendChild(slideDomClone);
				initSlider();
                // 商品価格と入力
                const orderForm = document.getElementById('order');
                orderForm.appendChild(orderJson(result.price));
                if (orderForm) {
                    orderForm.addEventListener('submit', orderClick);
                }
                const submit = document.createElement('input');
                submit.type = 'submit';
                submit.value = 'カートに入れる';
                orderForm.appendChild(submit);

                const desc = document.getElementById('description');
                if(result.description){
                    let h4 = document.createElement('h4');
                    h4.innerText = '商品説明';
                    desc.appendChild(h4);

                    let p = document.createElement('p');
                    p.innerText = result.description;
                    desc.appendChild(p);
                }

                if(result.precautions){
                    let h4 = document.createElement('h4');
                    h4.innerText = '注意事項';
                    desc.appendChild(h4);

                    let p = document.createElement('p');
                    p.innerText = result.precautions;
                    desc.appendChild(p);
                }
                
                let h4 = document.createElement('h4');
                h4.innerText = 'キャンセル';
                desc.appendChild(h4);
                
                let possibility = '不可';
                let p = document.createElement('p');
                if(result.cancel) possibility = '可能';
                p.innerText = possibility;
                desc.appendChild(p);

                // カレンダーが存在する時は変更時のイベントを登録
                const calender = document.getElementById('used-date-select');
                if(calender){
                    calender.addEventListener('change',calenderSelectorEvent);
                }
            } else {
                alert("通信に失敗しました");
            }
        } catch (error) {
            console.error("エラーが発生しました:", error);
        }
    }
});

// フォーム送信イベント
async function orderClick(event) {
    event.preventDefault();

    if (!orderCheck()){
        notInputModalOpen();
        return false;
    }

    // 非ログイン状態であればログインフォームにリダイレクト
    (async () => {
        const isLogin = await loginSession();
        if (!isLogin) {
            window.location.replace('/login/index.html');
        }
    })();

    // 注文情報を配列で取得
    const order = orderAcquisition();

    const orderData = {
        pi: pi,
        items: order
    };
    
    // 日付指定券の場合は日付けも送る
    const buyDate = document.getElementById('used-date-select');
    if(buyDate){
        orderData.date = buyDate.value;
    }

    const req = await fetch('/system/user/cart/add-to-cart.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(orderData)
    });
    const res = await req.json();
    if (res.success) {
        counterPlus();
        addCartModalOpen();
    } else {
        alert(res.message);
    }
}

function orderCheck() {
    const cartForm = document.getElementById('order');
    const listTags = cartForm.querySelectorAll('select');

    const flag = Array.from(listTags).some(item => item.value);
    return flag;
}

function orderAcquisition() {
    const listTags = document.getElementById('order').querySelectorAll('li');
    let orderArr = [];

    listTags.forEach((item) => {
        const orderNum = item.querySelector('select').value.trim();
        if (orderNum !== '' && !isNaN(orderNum) && Number(orderNum) > 0) {
            orderArr.push(Number(orderNum));
        }else{
            orderArr.push(0);
        }
    });
    return orderArr;
}

// カート追加時のモーダル
function addCartModalOpen(){
    const modal = document.getElementById('add-cart-modal');
    modal.style.display = 'block';
    const curtain = document.createElement('span');
    curtain.className = 'curtain';
    document.querySelector('body').appendChild(curtain);
    modal.querySelector('button').addEventListener('click',addCartModalClose);
}
function addCartModalClose(){
    document.getElementById('add-cart-modal').style.display = 'none';
    document.querySelector('.curtain').remove()
    
    const cartForm = document.getElementById('order');
    const listTags = cartForm.querySelectorAll('li');
    listTags.forEach((item) => {
        item.querySelector('select').value = '';
    })
}

// 個数が指定されていない時のモーダル
function notInputModalOpen(){
    const modal = document.getElementById('not-input-modal');
    modal.style.display = 'block';
    const curtain = document.createElement('span');
    curtain.className = 'curtain';
    document.querySelector('body').appendChild(curtain);
    modal.querySelector('button').addEventListener('click',notInputModalClose);
}
function notInputModalClose(){
    document.getElementById('not-input-modal').style.display = 'none';
    document.querySelector('.curtain').remove();
}

function counterPlus(){
    let cartItemCount = document.getElementById('cart-btn').querySelector('.count');
    let count = Number(cartItemCount.innerHTML);
    count = count + 1;
    cartItemCount.innerHTML = count;
}

function slideCreate(arr){
    const ul = document.createElement('ul');
    ul.classList.add('swiper-wrapper');
    if(arr !== null){
        for (const key in arr) {
            const li = document.createElement('li');
            li.classList.add('swiper-slide');
            const img = document.createElement('img');
            img.src = arr[key];
            li.appendChild(img);
            ul.appendChild(li);
        }
    }else{
        const defaultImg = '/images/common/default_thumb@2x.png';
        const li = document.createElement('li');
        li.classList.add('swiper-slide');
        const img = document.createElement('img');
        img.src = defaultImg;
        li.appendChild(img);
        ul.appendChild(li);
    }
    return ul;
}

// orderJsonをもとに購入個数入力欄を作成
function orderJson(arr) {
    if(arr['type'] === 'fixed' || arr['type'] === 'sdfixed'){
        const priceData = JSON.parse(arr['data']);
        const ul = document.createElement('ul');

        let options = '<option value="">0</option>';
        for(let i = 1; i <= 9; i++){
            options += '<option value="' + i + '">' + i + '</option>';
        }

        priceData.forEach((item) => {
            const li = document.createElement('li');
            const price = Number(item.categoryPrice);
            li.innerHTML = `
                <label>
                    <span class="js_keyname">${item.categoryName}</span> 
                    <span class="js_price">${price.toLocaleString()}</span>円
                </label>
                <div class="input-wrap">
                    個数：<select>${options}</select>
                </div>
            `;
            ul.appendChild(li);
        });

        return ul;
    }else if(arr['type'] === 'float'){
        const selectDateWrap = document.createElement('div');
        selectDateWrap.id = 'select_date_wrap';
        selectDateWrap.innerHTML = `
            <h4>ご利用日を選択してください。</h4>
            <p style="text-align:left;">※当商品は選択された日のみご利用いただけます。</p>
            <input type="date" name="used-date-select" id="used-date-select">
            <div id="input-wrap"></div>
        `;
        return selectDateWrap;
    }
}

async function calenderSelectorEvent(event){
    const req = await fetch('/system/user/ticket/date-ticket-read.php',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body: JSON.stringify({
            'date':event.target.value,
            'pid':pi
        })
    });
    const res = await req.json();
    if(res.success){
        dateTicketPriceRead(res.data);
    }else{
        console.error('エラーが発生しました。'+res.message)
    }
}

// 日付指定券の料金を読み込んで入力欄を作成
function dateTicketPriceRead(dateObj){
    if(dateObj.length !== 0){
        const ul = document.createElement('ul');
        let options = '<option value="">0</option>';
        for(let i = 1; i <= 9; i++){
            options += '<option value="' + i + '">' + i + '</option>';
        }
        dateObj.forEach((item) => {
            if(item){
                const li = document.createElement('li');
                const price = Number(item.price);
                li.innerHTML = `
                    <label>
                        <span class="js_keyname">${item.category}</span> 
                        <span class="js_price">${price.toLocaleString()}</span>円
                    </label>
                    <div class="input-wrap">
                        個数：<select>${options}</select>
                    </div>
                `;
                ul.appendChild(li);
            }
        });
        const appendTarget = document.getElementById('input-wrap');
        appendTarget.innerHTML = '';
        appendTarget.appendChild(ul);
    }else{
        const p = document.createElement('p');
        p.innerText = '選択された日付けは有効なチケットがありません。';
        const appendTarget = document.getElementById('input-wrap');
        appendTarget.innerHTML = '';
        appendTarget.appendChild(p);
    }
}